import React from "react";
import dynamic from "next/dynamic";

import { HeroVariant, LayoutHero } from "../../../../../core/types";
import { AppContext } from "../../../../../lib/appContext";
import { HeroData } from "./types";

/********************** Layouts for Hero **********************/
const DefaultHeroLayout = dynamic(() =>
  import(/* webpackChunkName: "DefaultHeroLayout" */ "../layouts/Default")
);

const StackedHeroLayout = dynamic(() =>
  import(/* webpackChunkName: "StackedHeroLayout" */ "../layouts/Stacked")
);

const DefaultWithQuoteLayout = dynamic(() =>
  import(/* webpackChunkName: "DefaultWithQuoteLayout" */ "../layouts/DefaultWithQuote").then(
    ({ DefaultWithQuote }) => DefaultWithQuote
  )
);

/********************** Variants for Hero **********************/
const DefaultHero = dynamic(() => import(/* webpackChunkName: "DefaultHero" */ "./DefaultHero"));
const RedirectHero = dynamic(() => import(/* webpackChunkName: "RedirectHero" */ "./RedirectHero"));
const DetachedHero = dynamic(() => import(/* webpackChunkName: "DetachedHero" */ "./DetachedHero"));
const FilterHero = dynamic(() => import(/* webpackChunkName: "FilterHero" */ "./FilterHero"));
const FormHero = dynamic(() => import(/* webpackChunkName: "FormHero" */ "./Form"));

const Promotion = dynamic(() =>
  import(/* webpackChunkName: "Promotion" */ "./Promotions/PromotionWithCTA")
);
const PromotionFilter = dynamic(() =>
  import(/* webpackChunkName: "PromotionWithFilter" */ "./Promotions/PromotionFilter")
);

const getHeroVariant = (variant?: HeroVariant) => {
  switch (variant) {
    case HeroVariant.Redirect:
      return RedirectHero;
    case HeroVariant.DetachedForm:
      return DetachedHero;
    case HeroVariant.Filter:
      return FilterHero;
    case HeroVariant.Form:
      return FormHero;
    case HeroVariant.Promotion:
      return Promotion;
    case HeroVariant.PromotionWithFilter:
      return PromotionFilter;
    default:
      return DefaultHero;
  }
};

const getLayoutHero = (layout?: LayoutHero) => {
  switch (layout) {
    case LayoutHero.Stacked:
      return StackedHeroLayout;
    case LayoutHero.DefaultWithQuote:
      return DefaultWithQuoteLayout;
    default:
      return DefaultHeroLayout;
  }
};

export const useHeroVariant = (): HeroData => {
  const { businessUnitConfig } = React.useContext(AppContext);
  const {
    widgets: {
      hero: { variant, layout }
    }
  } = businessUnitConfig;
  return {
    Layout: getLayoutHero(layout),
    Variant: getHeroVariant(variant)
  };
};
